import script from "./MeetingQuestionReview.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingQuestionReview.vue?vue&type=script&setup=true&lang=ts"

import "./MeetingQuestionReview.vue?vue&type=style&index=0&id=74ec52d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74ec52d6"]])

export default __exports__